import { render, staticRenderFns } from "./AuthorizationsStatistics.vue?vue&type=template&id=f949ab6a&scoped=true&"
import script from "./AuthorizationsStatistics.vue?vue&type=script&lang=js&"
export * from "./AuthorizationsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationsStatistics.vue?vue&type=style&index=0&id=f949ab6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f949ab6a",
  null
  
)

export default component.exports